import Vue from 'vue'
import Vuex from 'vuex'

import router from '@/router'

import { wait } from '@/modules/utils'

const INTERVAL_TO_TRANSITION = 250

Vue.use(Vuex)

const checkTablet = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    userAgent
  )
}

const store = new Vuex.Store({
  state: {
    isMobile: window.innerWidth <= 750,
    isTablet: checkTablet(),
    window: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    logoColor: 'white',
    isLoaded: false,
    isShowView: false,
    isTransition: true
  },
  mutations: {
    resize(state) {
      state.isMobile = window.innerWidth <= 750
      state.window = {
        width: window.innerWidth,
        height: window.innerHeight
      }
    },
    loaded(state) {
      state.isLoaded = true
    },

    showView(state) {
      state.isShowView = true
    },

    logoColorChange(state, color) {
      state.logoColor = color
    },

    initTransition(state) {
      state.isShowView = false
      state.isLoaded = false
    },

    startTransition(state) {
      state.isTransition = true
    },
    endTransition(state) {
      state.isTransition = false
    }
  },
  actions: {
    resize({ commit }) {
      commit('resize')
    },

    async debounceRouterPush(context, url) {
      if (context.state.isTransition === true) return
      context.commit('initTransition')
      context.commit('startTransition')
      await wait(INTERVAL_TO_TRANSITION)
      router.push(url)
    }
  }
})

export default store
